export const CONTENT_WRAPPER_FOR_CUSTOMIZATION = 'content-wrapper-for-customization';
export const CONTENT_WRAPPER = 'content-wrapper';
